<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Store No：{{ formData.amzStoreNo || 'New' }}
        </span>
        <el-divider
          direction="vertical"
          v-if="formData.v_amzStoreStatus"
        ></el-divider>
        <b-badge
          v-if="formData.v_amzStoreStatus"
          style="font-size: 12px"
          :variant="
            formData.amzStoreStatus === 'Y'
              ? 'success'
              : formData.amzStoreStatus === 'N'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_amzStoreStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_amzStoreName') || '店铺名称'"
            prop="amzStoreName"
          >
            <el-input
              v-model="formData.amzStoreName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_amzStoreAccount') || '店铺账号'"
            prop="amzStoreAccount"
          >
            <el-input
              v-model="formData.amzStoreAccount"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_amazonStoreRegion') || '店铺区域'"
            prop="amazonStoreRegion"
          >
            <dict-select
              v-model="formData.amazonStoreRegion"
              url="/ecom/amz/market/dictSelect"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_region') || '所属国家'"
            prop="regionCode"
          >
            <dict-select
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              url="/master/common/dict/biz"
              :body="regionParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_managerName') || '店长'"
            prop="managerCode"
          >
            <dict-select
              v-model="formData.managerCode"
              :selectedLabel.sync="formData.managerName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_isOwnInv') || '是否自有库存'">
            <el-select
              v-model="formData.isOwnInv"
              style="width:100%"
              @change="formData.invStoreCode = ''"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            >
              <el-option :label="'是'" value="Y"></el-option>
              <el-option :label="'否'" value="N"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_invStoreCode') || '库存店铺'"
            prop="invStoreCode"
          >
            <el-select
              v-if="formData.isOwnInv === 'N'"
              v-model="formData.invStoreCode"
              :placeholder="'请选择库存店铺'"
              filterable
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in invStoreOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              v-if="formData.isOwnInv !== 'N'"
              v-model="formData.amzStoreName"
              readonly
              :placeholder="'本店'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_amzStoreId') || '店铺ID'">
            <el-input
              v-model="formData.amzStoreId"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_currency') || '交易币种'">
            <dict-select
              v-model="formData.currency"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_loginMobile') || '登录手机号'">
            <el-input
              v-model="formData.loginMobile"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_ecomCompanyName') || '申请公司'">
            <dict-select
              v-model="formData.ecomCompanyCode"
              url="/ecom/ecomCompany/select"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_mobileProperties') || '手机性质'"
          >
            <el-input
              v-model="formData.mobileProperties"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_mobileOwnership') || '手机号归属'"
          >
            <el-input
              v-model="formData.mobileOwnership"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_mobileModel') || '手机品牌型号'">
            <el-input
              v-model="formData.mobileModel"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_loginType') || '登录方式'">
            <el-input
              v-model="formData.loginType"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_ipAddress') || 'IP地址'">
            <el-input
              v-model="formData.ipAddress"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_ipCountry') || 'IP所属国家'">
            <el-input
              v-model="formData.ipCountry"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_creditCardHolder') || '信用卡持卡人'"
          >
            <el-input
              v-model="formData.creditCardHolder"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_creditCardNo') || '信用卡卡号'">
            <el-input
              v-model="formData.creditCardNo"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_expiryDate') || '信用卡到期时间'"
          >
            <el-date-picker
              v-model="formData.expiryYearMonth"
              value-format="yyyy-MM"
              type="month"
              :picker-options="expiryYearMonthOption"
              style="width:100%"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '备注说明'">
            <el-input
              type="textarea"
              v-model="formData.remark"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              rows="2"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { request } from '@/api/service'
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    amzStoreCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      regionParams: { dictType: 'region' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      expiryYearMonthOption: {
        disabledDate: (time) => time.getTime() < Date.now() - 8.64e7,
      },
      formData: { isOwnInv: 'Y' },
      invStoreData: [],
    }
  },
  computed: {
    invStoreOption() {
      if (!this.amzStoreCode) return this.invStoreData
      return this.invStoreData.filter(
        (item) => item.value !== this.amzStoreCode
      )
    },
    rules() {
      return {
        amzStoreName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        amzStoreAccount: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        amazonStoreRegion: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        managerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        invStoreCode: [
          {
            trigger: 'change',
            required: this.formData.isOwnInv === 'N',
            validator: (rule, value, callback) => {
              const { isOwnInv } = this.formData
              if (isOwnInv === 'Y') {
                callback()
                return
              }
              if (!value) {
                callback(new Error('请选择库存店铺'))
                return
              }
              callback()
            },
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
    this.loadInvStore()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.amzStoreCode) return
      this.$api
        .ecomAmzStoreDetailApi({
          amzStoreCode: this.amzStoreCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async loadInvStore() {
      const url = '/ecom/amz/store/select'
      const res = await request({ url, method: 'POST' }).catch(() => null)
      if (!res) return
      this.invStoreData = res.body.data
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzStoreSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (!this.amzStoreCode) {
        this.closeCurPage()
      } else {
        this.getData()
      }
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
